module.exports = __webpack_public_path__ + "img/关于顶部图.6e090a81.png";